const BlockJumpDefault = {
    object_id : null,
    name : 'Jump to ...',
    x : 0,
    y : 0,
    width : 5,
    height : 2,
    type : { name : 'magic'},
    data : { jump_id : null, is_constant : true },
}

const BlockJumpServerDefault = {
    type : 'magic',
    jump_id : null,
}

export { BlockJumpDefault, BlockJumpServerDefault}